import { Box, Text, Path } from '@st/document-rendering'
import { StampAnnotation } from '@st/sdk'
import { memo } from 'react'
import { LinearTransform } from '@st/geom'
import { STAMP_GLYPHS } from './stamp-glyphs'

export const StampView = memo(StampViewBase)

function StampViewBase({ annotation }: { annotation: Omit<StampAnnotation, 'id' | 'time'> }) {
  const glyphSpec = STAMP_GLYPHS[annotation.text]

  return (
    <Box
      width={annotation.bounds.width}
      height={annotation.bounds.height}
      backgroundColor={annotation.backgroundColor}
      alignment="center"
      border={
        annotation.border
          ? {
              color: annotation.border.color!,
              width: annotation.border.width,
              radius: annotation.border.radius
            }
          : undefined
      }
    >
      {glyphSpec ? (
        <Path
          d={glyphSpec.path}
          fill={annotation.color}
          transform={LinearTransform.scale(annotation.bounds.width / glyphSpec.size)}
        />
      ) : (
        <Text
          fontFamily={annotation.font.family}
          fontSize={annotation.font.size}
          color={annotation.color}
        >
          {annotation.text}
        </Text>
      )}
    </Box>
  )
}
